import { render, staticRenderFns } from "./MiniNotification.vue?vue&type=template&id=5cbde9c2&scoped=true&"
import script from "./MiniNotification.vue?vue&type=script&lang=js&"
export * from "./MiniNotification.vue?vue&type=script&lang=js&"
import style0 from "./MiniNotification.vue?vue&type=style&index=0&id=5cbde9c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbde9c2",
  null
  
)

export default component.exports